import type { CurrencyCode } from '@/lib/money'
import { cn } from '@/lib/cn'
import styles from './CurrencyBadge.module.css'

/**
 * Gradient coin per currency, matching the canvas. Both stops pass contrast.
 * The dollar is the home currency, so it takes the brand accent rather than a
 * fixed colour — a literal lime here shipped Pass's palette into Dracma.
 */
const COIN: Record<CurrencyCode, { readonly from: string; readonly to: string; readonly ink?: boolean }> = {
  USD: { from: 'var(--pb-accent-soft)', to: 'var(--pb-accent)', ink: true },
  EUR: { from: '#6a57e6', to: '#4f3cc9' },
  MXN: { from: '#12897a', to: '#0f5f59' },
  BRL: { from: '#c96707', to: '#9a4507' },
  GBP: { from: '#d93c79', to: '#a8154f' },
  COP: { from: '#5c5c66', to: '#3f3f46' },
  BOB: { from: '#0f86a6', to: '#0e7490' },
  USDC: { from: '#0a7fbe', to: '#03608f' },
}

export function CurrencyBadge({
  currency,
  size = 40,
  className,
}: {
  readonly currency: CurrencyCode
  readonly size?: number | undefined
  readonly className?: string | undefined
}) {
  const coin = COIN[currency]
  return (
    <span
      className={cn(styles.badge, coin.ink && styles.onInk, className)}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(10, Math.round(size * (currency.length > 3 ? 0.26 : 0.3))),
        background: `linear-gradient(135deg, ${coin.from}, ${coin.to})`,
      }}
      aria-hidden="true"
    >
      {currency}
    </span>
  )
}
